import { format } from "date-fns";
import { ParentContext } from "global/cnr/contexts/ParentContext";
import { RssContext } from "global/cnr/contexts/RssContext";
import { useRssFeed } from "global/cnr/contexts/useHelpers/useRssFeed";
import UiSaveButtons from "global/components/buttons/UiSaveButtons";
import ItemMenuSquares, { _imsTypes } from "global/wrappers/ItemMenuSquares";
import Wrapper, { wrapperTypes } from "global/wrappers/Wrapper";
import WrapperVertCols from "global/wrappers/WrapperVertCols";
import { FeedSquares } from "globalAlt/components/rss/FeedSquares";
import { SportsDistrictContext } from "projectSpecific/sports/cnr/contexts/SportsDistrictContext";
import { SportsSeasonContext } from "projectSpecific/sports/cnr/contexts/SportsSeasonContext";
import { useContext, useEffect, useState } from "react";
import { Form, Header, Icon } from "semantic-ui-react";

const RssSearchDashboard = () => {

  const parentContext = useContext(ParentContext);
  const { settings, fn_cls } = parentContext ?? {}
  const { getFeed } = fn_cls ?? {}
  const { homeSettings } = settings ?? {}
  const { global: homeSettings_global } = homeSettings ?? {}
  const { rssFeeds: rssFeeds_home } = homeSettings_global ?? {}

  const sportsDistrictContext = useContext(SportsDistrictContext)
  const { sportsDistrict_state } = sportsDistrictContext ?? {}
  const { district_data } = sportsDistrict_state ?? {}
  const { rssFeeders } = district_data ?? {}

  const sportsSeasonContext = useContext(SportsSeasonContext)
  const { sportsSeason_state } = sportsSeasonContext ?? {}

  // RSS Context
  const { rss_state } = useContext(RssContext) ?? {}
  const { mediaFeeds, mediaFeedMessage } = rss_state ?? {}

  const { getRssFeed, updateRssFeeders, updateRssFeeds, updating } = useRssFeed()

  const [allFeeds, setAllFeeds] = useState({});
  const [selectedFeed, setSelectedFeed] = useState({});
  const [url, setUrl] = useState('');
  const [titleSearch, setTitleSearch] = useState('');
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const _rssFeeds_home = _.cloneDeep(rssFeeds_home)
    _.forEach(_rssFeeds_home, (rss, rssKey) => {
      rss.name = rss.source
      rss._itemKey = rssKey
    })
    setAllFeeds(_rssFeeds_home)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rssFeeds_home]);

  const handleSearch = async () => {
    if (!url) return;
    setLoading(true);
    try {
      // const weekCount = 18
      //  const weeks = _.range(1, weekCount + 1);
      //  console.log('weeks', weeks)
      // const xxx = await fsfn_getSchedule(url, weekCount, true)
      // const { result } = xxx ?? {}
      // console.log('result', result)
      // const { allEvents } = result ?? {}
      // console.log('allEvents', allEvents)
      // const allEvents_g = _.groupBy(allEvents, 'week.number')
      // console.log('allEvents_g', allEvents_g)

      const cb = (items) => {
        console.log('items', items)
        setItems(items);
      }

      getRssFeed({ selectedFeed, url: url, titleSearch, callback: cb })
    } catch (err) {
      console.error("Error parsing RSS feed:", err);
      setItems([]);
    }
    setLoading(false);
  };

  const handleChange_selectedFeed = (item) => {
    if (allFeeds[item._itemKey]) {
      setSelectedFeed(item._itemKey)
      setUrl(allFeeds[item._itemKey].baseUrl)
    }
  }

  const handleUpdateRssFeed = (item) => {
    updateRssFeeders({
      rssFeeder: {
        _itemKey: item._itemKey,
        active: !item.active
      }
    })
  }

  const externals = {
    rss: () => window.open(url, '_blank')
  }

  const frm_search = () => wrapper_generic(selectedFeed ? _.startCase(selectedFeed) : 'Selected', <Form>
    <Form.Input
      fluid
      label={'Rss Url'}
      placeholder="Enter RSS feed URL..."
      value={url}
      onChange={(e) => setUrl(e.target.value)}
      style={{ marginBottom: "1em" }}
    />

    <Form.Input
      fluid
      label={'Title'}
      placeholder="Search by title..."
      value={titleSearch}
      onChange={(e) => setTitleSearch(e.target.value)}
      style={{ marginBottom: "1em" }}
    />
  </Form>,
    <UiSaveButtons
      save={{ caption: 'Search', icon: 'search', oc: handleSearch, color: 'blue' }}
      preview={{ caption: 'Open Url', icon: 'external alternate', oc: externals.rss, color: 'orange' }}
    />
  )

  const fnAlt_feeds = (item) => {
    const _itemKey = _.camelCase(item?._itemKey || item?.name || item?.source)
    const active = rssFeeders?.[_itemKey]?.active
    return <Icon
      name={active ? 'check circle outline' : 'circle outline'}
      color={active ? 'green' : 'grey'}
      onClick={(e) => { handleUpdateRssFeed(item) }}
    />
  }

  const fnAlt_feed = (item) => {
    const formattedDate = format(new Date(item?.pubDate), 'MM/dd/yyyy');
    return formattedDate
  }

  // const ims_feeds = () => <ItemMenuSquares
  //   menuItems={items}
  //   fn_altContent={fnAlt_feed}
  //   imsType={_imsTypes.inline}
  //   iconItem={'rss'}
  // />

  const handleSelect_feed = (e, item) => {
    e.stopPropagation()
    const _items = _.cloneDeep(items)
    const _item = _.find(_items, { title: item.title })
    _item._selected = !_item._selected
    console.log('_items', _items)
    setItems(_items)
  }

  const handleUpdate_feeds = () => {
    const _items = _.filter(items, { _selected: true })
    console.log('_items', _items)
    updateRssFeeds({ rssFeeds: _items })
  }

  const footer_save = (item) => {
    return <UiSaveButtons
      save={{
        oc: handleUpdate_feeds,
        caption: 'Update Feeds',
      }}
    />
  }

  const wrapper_feeds = () => <Wrapper
    header={'Latest Feeds'}
    content={<FeedSquares
      allFeeds={items}
      allowSave={true}
      handleSelect={handleSelect_feed}
    />}
    wrapperType={wrapperTypes.padded}
    footer={!_.isEmpty(items) && footer_save()}
  >
  </Wrapper>

  const youtub_list = () => <Wrapper
    Header={<Header as="h2">You Tube</Header>}
    content={ifr()}
    css={{ container: 'app-dark-mode' }}
  ></Wrapper>

  const ifr = () => <div className="iframe-container"><iframe
    width="100%"
    height="500"
    src="https://www.youtube.com/embed/videoseries?list=UUKHIxkfiTl1ipOzzqzw3R5Q"
    // src='https://youtube.com/@fxcathletics?si=BWt0-egBTi5TLOyP'
    frameborder="0"
    allowfullscreen>
  </iframe></div>

  const wrapper_generic = (caption, content, footer) => <Wrapper
    header={caption}
    content={content}
    footer={footer}
    wrapperType={wrapperTypes.padded}
  ></Wrapper>

  const ims_rss = () => wrapper_generic('Rss Feeds', <ItemMenuSquares
    menuItems={_.sortBy(allFeeds, 'name')}
    imsType={_imsTypes.inline}
    onClick={handleChange_selectedFeed}
    activeItem={selectedFeed}
    iconItem={'globe'}
    fn_altContent={fnAlt_feeds}
  ></ItemMenuSquares>)

  const mvc = () => <WrapperVertCols mvc={'3'}>
    {ims_rss()}
    {frm_search()}
    {wrapper_feeds()}
    {/* {youtub_list()} */}
  </WrapperVertCols>

  return (
    <Wrapper
      Header={<Header as="h2">RSS Feed Search</Header>}
      content={mvc()}
      css={{ container: 'app-dark-mode' }}
    ></Wrapper>
  );
};

export default RssSearchDashboard;
